import { RmaRequest } from 'components/ordering/rma/api/rma-request.js'

export class CreateTemporaryRmaLineUpload extends RmaRequest<string, never> {
  path: string
  override init: RequestInit = { method: 'POST' }

  constructor({ identifier }: { identifier: string }) {
    super()
    this.path = `account/rma/draft/upload/temporary/${identifier}/`
  }
}
